var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('div',{class:{ nav: _vm.artist_role }},[(_vm.admin_role)?_c('Admin'):_vm._e(),(_vm.artist_role)?_c('Artist'):_vm._e(),(_vm.label_role)?_c('Label'):_vm._e(),(_vm.content_role)?_c('Content'):_vm._e(),(_vm.mcn_role)?_c('Mcn'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }